import { useQuery } from '@apollo/react-hooks';

import { SYLLABUS_MODE } from 'Domains/syllabus';
import { getCourseSectionReport, getTKCourseSectionReport } from 'GraphQL/queries/report.query';

const CourseSectionReportData = ({ value, schoolCode, children }) => {
  const { term, grade, subject, syllabus, mode } = value;

  const variables = {
    schoolTermId: term,
    schoolGradeId: grade,
    subjectId: subject,
    courseCode: syllabus,
    schoolCode,
  };

  const isSkip = !term || !grade || !subject || !syllabus || !schoolCode;

  const traditionalReport = useQuery(getCourseSectionReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TUNGKAI,
  });

  const tungkaiReport = useQuery(getTKCourseSectionReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TRADITIONAL,
  });

  const report = mode === SYLLABUS_MODE.TRADITIONAL ? traditionalReport : tungkaiReport;

  const { loading, error, data, refetch } = report;

  return children({ loading, error, data, refetch });
};

export default CourseSectionReportData;
